var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'ExamIndex' }}},[_vm._v(_vm._s(_vm.bread))])
}
var staticRenderFns = []

export { render, staticRenderFns }